import styled from '@emotion/styled';
import { mediaQuery } from '@presentation/styles';

export const CardContainer = styled.div`
  padding: 15px 0px;
  display: flex;
  flex-wrap: wrap;
`;

export const CardWrapper = styled.div`
  padding: 15px;
  width: ${(1 / 3) * 100}%;
  max-width: 420px;
  min-width: 400px;

  ${mediaQuery(1500)} {
    width: 50%;
  }

  ${mediaQuery('small')} {
    min-width: auto;
    min-height: 300px;
    width: 100%;
  }
`;

export const EmptyWrapper = styled.div`
  flex-direction: column;
  display: flex;
  align-items: center;
  margin-top: 100px;
  & > *:not(:last-child) {
    margin-bottom: 20px;
  }
  padding: 50px;
  text-align: center;
  max-width: 700px;
  margin: 0 auto;
  color: ${(props) => props.theme.color.medium.default};

  ${mediaQuery('small')} {
    padding: 20px;
  }
`;
